module.exports = __webpack_public_path__ + "img/1_05.748bd89e.jpg";